// extracted by mini-css-extract-plugin
export default {"container":"Suites_4_container__R7xcg","swiperBox":"Suites_4_swiperBox__Xpt2d","cover":"Suites_4_cover__fc5nl","textBox":"Suites_4_textBox__PPW10"};